import _ from 'lodash'
import store from '@/store/index'

/**
 * 自定义表达式
 */
const expressionOperator = {
  // 选中
  eq: function (v1, v2) {
    if (!v1 && v1 !== 0) {
      return false
    }
    // 当type=CHECK_BOX时此处应为包含关系
    return Array.isArray(v1) ? v1.includes(+v2) : v1 == v2
  },
  // 未选中
  ne: function (v1, v2) {
    // if (!v1) {
    //   return false
    // }
    return Array.isArray(v1) ? !v1.includes(+v2) : v1 != v2
  },
  // 大于
  gt: function (v1, v2) {
    return v1 === '' || v1 === null ? false : v1 > v2
  },
  // 大于等于
  ge: function (v1, v2) {
    return v1 === '' || v1 === null ? false : (v1 > v2) | (v1 == v2)
  },
  // 小于
  lt: function (v1, v2) {
    return v1 === '' || v1 === null ? false : v1 < v2
  },
  // 小于等于
  le: function (v1, v2) {
    return v1 === '' || v1 === null ? false : (v1 < v2) | (v1 == v2)
  },
  // 包含
  include: function (v1, v2) {
    let flag = false
    const paramData = v2.split('|')
    const { logicParams } = store.state.form
    const logicSourceData = logicParams && logicParams[v1] ? logicParams[v1].split('|') : []
    for (let i = 0; i < paramData.length; i++) {
      flag = includeFn(logicSourceData, paramData[i])
      if (flag) break
    }
    return flag
  },
  // 不包含
  uninclude: function (v1, v2) {
    let flag = 0
    const paramData = v2.split('|')
    const { logicParams } = store.state.form
    const logicSourceData = logicParams && logicParams[v1] ? logicParams[v1].split('|') : []
    for (let i = 0; i < paramData.length; i++) {
      logicSourceData.forEach((item) => {
        if (item === paramData[i]) flag++
      })
    }
    return flag === 0
  }
}

function includeFn(data, val) {
  let includeFlag = false
  for (let i = 0; i < data.length; i++) {
    if (data[i] === val) {
      includeFlag = true
      break
    }
  }
  return includeFlag
}

/**
 * 逻辑连接符
 * @type {{'1': string, '2': string}}
 */
const LogicConnector = {
  1: 'and',
  2: 'or'
}

/**
 * 执行表达式是否成立
 */
export function evalExpression(context, logic) {
  let flag = false
  const { formItemId, expression, optionValue, parameterValue, type, parameter } = logic
  const val = type === '_PARAMETERS' ? parameterValue : optionValue
  const fieldId = type === '_PARAMETERS' ? parameter : formItemId
  let fieldValue = _.get(context, fieldId, fieldId)
  if (expression === 'undefined' || expression === 'null') {
    return false
  }
  // 比较是否成立
  flag = expressionOperator[expression](fieldValue, val)
  return flag
}

/**
 * 通用条件拆分函数：按 relation 拆分逻辑为二维数组
 * relation = 'AND' 代表“断开点”, 先计算and 再计算 or
 * 比如 条件1 or 条件2 and 条件3 等于  条件1为true 或者 （条件2且条件3都为true）
 */
function splitConditionsByRelation(list, mapFn = null, mapContext = null) {
  const result = []
  let current = []
  for (const item of list) {
    const value = mapFn ? mapFn(mapContext, item) : item
    if (item.relation === 'AND') {
      current.push(value)
    } else {
      if (current.length) result.push(current.every(Boolean))
      current = [value]
    }
  }
  if (current.length) result.push(current.every(Boolean))
  return result
}
// 判断条件组是否为真-- 依赖于单个条件结果
function evaluateCondition(formModel, logic) {
  const groupList = splitConditionsByRelation(logic.conditionList, evalExpression, formModel)
  return groupList.some(Boolean)
}
// 判断逻辑组是否为真--依赖于条件组的结果
function evaluateConditionGroup(formModel, group) {
  const groupList = splitConditionsByRelation(group, evaluateCondition, formModel)
  return groupList.some(Boolean)
}
export function isShown(formModel, rules) {
  // 有多个逻辑组控制同一道题时，视为“并且”关系，当所有逻辑都满足时才显示
  return rules.every((group) => evaluateConditionGroup(formModel, group))
}
